import { render, staticRenderFns } from "./editorSelectionPopover.vue?vue&type=template&id=d4c9ad24&scoped=true&"
import script from "./editorSelectionPopover.vue?vue&type=script&lang=js&"
export * from "./editorSelectionPopover.vue?vue&type=script&lang=js&"
import style0 from "./editorSelectionPopover.vue?vue&type=style&index=0&id=d4c9ad24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c9ad24",
  null
  
)

export default component.exports